export default "__VITE_ASSET__bdFG6wOz__"